// removed by extract-text-webpack-plugin
module.exports = {"section":"src-components-Section----styles-module---section---3it4s","fullBleed":"src-components-Section----styles-module---fullBleed---1Ppi1","hasBgImg":"src-components-Section----styles-module---hasBgImg---3cJcm","dark":"src-components-Section----styles-module---dark---1j7is","title":"src-components-Section----styles-module---title---Z9skz","text":"src-components-Section----styles-module---text---2c6a9","backgroundImage":"src-components-Section----styles-module---backgroundImage---3Umwp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/styles.module.css
// module id = 508
// module chunks = 168707334958949